if (!window.__variantImageSyncLoaded) {
  window.__variantImageSyncLoaded = true;
  (function () {
    var TAG = '[variant-image-sync]';
    var desktop = window.matchMedia('(min-width: 750px)');

    function selectedOptions(vs) {
      var out = [];
      vs.querySelectorAll('fieldset, .product-form__input--dropdown').forEach(function (g) {
        var r = g.querySelector('input[type=radio]:checked');
        if (r) { out.push(r.value); return; }
        var s = g.querySelector('select');
        if (s) out.push(s.value);
      });
      return out;
    }

    function entryForOptions(productInfo, opts) {
      var el = productInfo.querySelector('script[data-variant-media]');
      if (!el) return null;
      var data;
      try { data = JSON.parse(el.textContent); } catch (e) { return null; }
      for (var i = 0; i < data.length; i++) {
        var o = data[i].options || [];
        if (o.length === opts.length && o.every(function (v, k) { return v === opts[k]; })) return data[i];
      }
      return null;
    }

    function reveal(slide) {
      slide.classList.remove('scroll-trigger--offscreen');
      slide.classList.add('scroll-trigger--cancel');
      slide.style.opacity = '1';
      slide.querySelectorAll('img').forEach(function (img) {
        if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      });
    }

    // Make every slide of every gallery visible and loadable (the theme's scroll-reveal fade-in can leave
    // slides that start outside the viewport invisible, e.g. the next images in the mobile slider).
    function revealAll(root) {
      (root || document).querySelectorAll('media-gallery li.product__media-item').forEach(reveal);
    }

    // Desktop thumbnail layout shows ONE main image (the active slide). On mobile every slide must stay
    // displayed (it is a swipe slider), so any inline display set while the page was desktop-wide is cleared.
    // This runs again whenever the viewport crosses the desktop/mobile breakpoint.
    function applyLayout(root) {
      (root || document).querySelectorAll('media-gallery').forEach(function (gallery) {
        var thumbLayout = (gallery.dataset.desktopLayout || '').indexOf('thumbnail') > -1;
        gallery.querySelectorAll('li.product__media-item').forEach(function (li) {
          if (thumbLayout && desktop.matches) {
            li.style.display = li.classList.contains('is-active') ? 'block' : 'none';
          } else {
            li.style.display = '';
          }
        });
      });
    }
    function onBreakpointChange() { applyLayout(); revealAll(); }
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpointChange);
    else if (desktop.addListener) desktop.addListener(onBreakpointChange);
    window.addEventListener('resize', function () {
      // Safety net: if the viewport is mobile-sized, never leave a slide hidden inline.
      if (!desktop.matches) applyLayout();
    });

    /* Make the variant's image the active one WITHOUT changing the order of the gallery.
       scrollMode controls the horizontal slider (mobile / slider layouts):
         'none'   - only update state, do not scroll
         'smooth' - slide (animated) to the image's own position
         'fix'    - jump to it only if the slider is not already there (no animation) */
    function syncGalleryState(productInfo, entry, scrollMode) {
      var wanted = productInfo.dataset.section + '-' + entry.media;
      productInfo.querySelectorAll('media-gallery').forEach(function (gallery) {
        var list = gallery.querySelector('ul.product__media-list') || gallery.querySelector('ul');
        if (list) {
          var slides = Array.prototype.slice.call(list.querySelectorAll('li[data-media-id]'));
          var target = slides.filter(function (li) { return li.dataset.mediaId === wanted; })[0];
          if (target) {
            slides.forEach(function (li) {
              if (li !== target) li.classList.remove('is-active');
              reveal(li);
            });
            target.classList.add('is-active');
            applyLayout(gallery.parentElement || document);
            if (scrollMode !== 'none' && list.scrollWidth > list.clientWidth + 1) {
              if (Math.abs(list.scrollLeft - target.offsetLeft) > 2) {
                try {
                  list.scrollTo({ left: target.offsetLeft, behavior: scrollMode === 'smooth' ? 'smooth' : 'instant' });
                } catch (e) {
                  list.scrollLeft = target.offsetLeft;
                }
              }
            }
          }
        }
        var thumbList = gallery.querySelector('ul.thumbnail-list');
        if (thumbList) {
          Array.prototype.slice.call(thumbList.querySelectorAll('li[data-target]')).forEach(function (li) {
            var b = li.querySelector('button');
            if (!b) return;
            if (li.dataset.target === wanted) {
              b.setAttribute('aria-current', 'true');
            } else {
              b.removeAttribute('aria-current');
            }
          });
        }
        var activeSlide = list && list.querySelector('li.is-active');
        gallery.querySelectorAll('.slider-dot').forEach(function (dot) {
          var on = !!activeSlide && dot.dataset.target === activeSlide.id;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      });
    }

    // steps: array of [delayMs, scrollMode]
    function run(productInfo, entry, steps) {
      steps.forEach(function (step) {
        setTimeout(function () {
          try { syncGalleryState(productInfo, entry, step[1]); } catch (e) { console.error(TAG, e); }
        }, step[0]);
      });
    }

    // While the new variant data is still loading, only update which image is marked active
    // (no scrolling). The slide happens once, after the theme has finished updating the gallery.
    document.addEventListener('change', function (event) {
      var vs = event.target.closest && event.target.closest('variant-selects');
      if (!vs) return;
      var productInfo = vs.closest('product-info');
      if (!productInfo) return;
      var entry = entryForOptions(productInfo, selectedOptions(vs));
      if (!entry || !entry.media) return;
      run(productInfo, entry, [[0, 'none']]);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var data = (payload && payload.data) || {};
        if (!data.variant) return;
        document.querySelectorAll('product-info').forEach(function (pi) {
          var sid = pi.dataset.originalSection || pi.dataset.section;
          if (sid !== data.sectionId) return;
          var vs = pi.querySelector('variant-selects');
          var entry = vs && entryForOptions(pi, selectedOptions(vs));
          // One animated slide to the image, then state-only syncs, then a silent safety correction.
          if (entry && entry.media) run(pi, entry, [[0, 'smooth'], [150, 'none'], [900, 'fix']]);
        });
      });
    }

    // Page load: reveal all slides, and if a variant is preselected open on that image's own position.
    function initialSync() {
      [0, 300, 900, 2000].forEach(function (ms) {
        setTimeout(function () { try { revealAll(); applyLayout(); } catch (e) {} }, ms);
      });
      document.querySelectorAll('product-info').forEach(function (pi) {
        var vs = pi.querySelector('variant-selects');
        var entry = vs && entryForOptions(pi, selectedOptions(vs));
        if (entry && entry.media) run(pi, entry, [[0, 'fix'], [300, 'fix']]);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialSync);
    } else {
      initialSync();
    }
    // Also covers product sections that are swapped in later (quick add, section re-render).
    document.addEventListener('product-info:loaded', function () {
      [0, 300].forEach(function (ms) {
        setTimeout(function () { try { revealAll(); applyLayout(); } catch (e) {} }, ms);
      });
    });
  })();
}

/* ---------------------------------------------------------------------------
   THUMBNAIL CLICK -> MAIN IMAGE (desktop)
   Reveals the clicked thumbnail's slide and makes it the only visible main image.
   --------------------------------------------------------------------------- */
if (!window.__thumbClickFixLoaded) {
  window.__thumbClickFixLoaded = true;
  (function () {
    var desktop = window.matchMedia('(min-width: 750px)');

    function reveal(slide) {
      slide.classList.remove('scroll-trigger--offscreen');
      slide.classList.add('scroll-trigger--cancel');
      slide.style.opacity = '1';
      slide.querySelectorAll('img').forEach(function (img) {
        if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      });
    }

    document.addEventListener('click', function (event) {
      var item = event.target.closest && event.target.closest('.thumbnail-list__item[data-target]');
      if (!item) return;
      var gallery = item.closest('media-gallery');
      if (!gallery) return;
      var id = item.dataset.target;
      var thumbLayout = (gallery.dataset.desktopLayout || '').indexOf('thumbnail') > -1;
      [0, 120, 400].forEach(function (ms) {
        setTimeout(function () {
          var slides = gallery.querySelectorAll('li.product__media-item[data-media-id]');
          var target = null;
          slides.forEach(function (s) { if (s.dataset.mediaId === id) target = s; });
          if (!target) return;
          slides.forEach(function (s) {
            s.classList.toggle('is-active', s === target);
            if (thumbLayout && desktop.matches) s.style.display = s === target ? 'block' : 'none';
            else s.style.display = '';
          });
          reveal(target);
        }, ms);
      });
    });
  })();
}
